import { geCustomertPaymentDetails } from "../components/createpaymentlink/service"

const SET_PAYMENT_DETAILS = "setPaymentDetails"
const GET_PAYEMENT_LINK_DETAILS = 'getPaymentLinkDetails'
const setPaymentDetails = (payload) => {
    return {
        type: SET_PAYMENT_DETAILS,
        payload
    }
}
export const getPaymentLinkDetails = (payload) => {
    return {
        type: GET_PAYEMENT_LINK_DETAILS,
        payload
    }
}
const initialValues = {
    paymentDetails: null,
    viewPaymentDetails:{ isLoading: false, data: {}, error: null},
}
const fetchPaymentDetails = (id) => {
    return async (dispatch) => {
        dispatch(getPaymentLinkDetails({ key: "viewPaymentDetails", isLoading: true, data: null }));
        const response = await geCustomertPaymentDetails('Merchant/paymentdetail', id);
        if (response) {
            dispatch(getPaymentLinkDetails({ key: "viewPaymentDetails", isLoading: false, data: response }));
        } else {
            dispatch(getPaymentLinkDetails({ key: "viewPaymentDetails", isLoading: false, data: null, error: response.originalError.message }));
        }
    }
}

const PayMentReducer = (state, action) => {
    if (!state) {
        state = { ...initialValues, ...state }
    }
    switch (action.type) {
        case SET_PAYMENT_DETAILS: {
            state = { ...state, paymentDetails: action.payload }
            return state;
        }
        case GET_PAYEMENT_LINK_DETAILS:
            return {
                ...state, [action.payload.key]: {
                    data: action.payload.data,
                    error: action.payload.error,
                    isLoading: action.payload.isLoading,
                }
            };
        default:
            return state;
    }
}
export default PayMentReducer;
export { setPaymentDetails,fetchPaymentDetails }